module.exports = __webpack_public_path__ + "static/media/Ian Collins.95671ab5.jpeg";